import { render, staticRenderFns } from "./ToolboxTalkLibraryItemShow.vue?vue&type=template&id=96b25bce&"
import script from "./ToolboxTalkLibraryItemShow.vue?vue&type=script&lang=js&"
export * from "./ToolboxTalkLibraryItemShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports